import React, { useEffect, useState } from 'react';
import { 
    Box, 
    Typography, 
    Stack, 
    Grid, 
    List, 
    ListItem, 
    Link, 
    ImageList,
    ImageListItem,
    Tooltip } from '@mui/material';
import VerifyUser from './assets/icons/verify2.svg';
import VerifyCompany from './assets/icons/verify1.svg';
import VerifyReo from './assets/icons/verify3.svg';


import BatteryLogo from './assets/icons/batteries.svg';
import PaperLogo from './assets/icons/paper.svg';
import MetalLogo from './assets/icons/metal.svg';
import TetrapakLogo from './assets/icons/tetrapak.svg';
import GlassLogo from './assets/icons/glass.svg';
import TyreLogo from  './assets/icons/wheel.svg';
import HazardLogo from './assets/icons/biohazard.svg';
import PlasticLogo from './assets/icons/plastic.svg';

import PetLogo from './assets/icons/pet.svg';
import LampLogo from './assets/icons/lamps.svg';
import AluLogo from './assets/icons/alu.svg';
import AppliancesLogo from './assets/icons/apliances.svg';
import CapLogo from './assets/icons/caps.svg';
import WearLogo from './assets/icons/wear.svg';
import CloseLogo from "./assets/icons/close.svg";
import WarningLogo from "./assets/icons/warning.svg";
import ShoesLogo from "./assets/icons/shoes.svg";
import OtherLogo from "./assets/icons/other.svg";
import MedicineLogo from "./assets/icons/drugs.svg";
import Moment from 'react-moment';
import moment from 'moment';


import {
    uberuGreenColor, 
    uberuLightGreenColor, 
    apiURL, 
    uberuLightGreen2Color,
    uberuRedColor
} from './Constants'
import axios from 'axios';

// import './assets/css/mycss.css';
import "@fontsource/manrope";
import '@fontsource/manrope/200.css';
import '@fontsource/manrope/300.css';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

  const pointTypes = [
    {
      Name : "На улице",
      Id : 1
    },
    {
      Name : "Отдельное здание",
      Id : 2
    },
    {
      Name : "Автоматический",
      Id : 3
    },
    {
      Name : "В помещении",
      Id : 4
    },
    {
      Name : "Экоцентр",
      Id : 5
    },
    {
      Name : "Мобильный",
      Id : 6
    },
  ]
  
const bonusTypes = [
    {
      Name : "Нет бонусов",
      Id : 0
    },
    {
      Name : "Уберу",
      Id : 1
    },
    {
      Name : "Собственная система",
      Id : 2
    },
    {
      Name : "Бум буттл",
      Id : 3
    }
  ]
  


const  ModalUberu = (props) => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [tabSelected, setTabSelected] = useState(0);
    const [imagesPoint, setImagesPoint ] = useState([]);
    const [pointSchedule, setPointSchedule ] = useState(null);
    const [isNowOpen, setIsNowOpen ] = useState(true);

    useEffect(() => {
        //console.log(props)
        props.onOpen()
        getPointImages(props.data.Id)
        createPointSchedule(props.data)
        //console.log(props.data)
    }, [props])

    const getPointImages = (id) =>{
        axios({
          method: 'get',
          url: apiURL + 'GetImagesPoint',
          params:{
            id: id
          }
        })
        .then((response) => {
            //console.log(response.data)
            setImagesPoint(response.data);
        })
        .catch((error) => {
            setImagesPoint([]);
        });
      }

      const createPointSchedule = (data) =>{
        try{
        var scheduleTemp = [
          {
            day: 1, 
            beg: data.MonBegTime,
            end: data.MonEndTime,
            dayText: "Пн.",
            sch:"C"+" "+ data.MonBegTime.toString() + " "+  "до" + " " + data.MonEndTime.toString()
          },
          {
            day: 2, 
            beg: data.TueBegTime,
            end: data.TueEndTime,
            dayText: "Вт",
            sch:"C"+" "+ data.TueBegTime.toString() + " "+  "до" + " " + data.TueEndTime.toString()
          },
          {
            day: 3,
            beg: data.WedBegTime,
            end: data.WedEndTime,
            dayText: "Ср",
            sch:"C"+" "+ data.WedBegTime.toString() + " "+  "до" + " " + data.WedEndTime.toString()
          },
          {
            day: 4,
            beg: data.ThuBegTime,
            end: data.ThuEndTime,
            dayText: "Чт",
            sch:"C"+" "+ data.ThuBegTime.toString() + " "+  "до" + " " + data.ThuEndTime.toString()
          },
          {
            day: 5,
            beg: data.FriBegTime,
            end: data.FriEndTime,
            dayText: "Пт",
            sch:"C"+" "+ data.FriBegTime.toString() + " "+  "до" + " " + data.FriEndTime.toString()
          },
          {
            day: 6,
            beg: data.SatBegTime,
            end: data.SatEndTime,
            dayText: "Сб",
            sch: "C"+" "+ data.SatBegTime.toString() + " "+  "до" + " " + data.SatEndTime.toString()
          },
          {
            day: 7,
            beg: data.SunBegTime,
            end: data.SunEndTime,
            dayText: "Вс",
            sch: "C"+" "+ data.SunBegTime.toString() + " "+  "до" + " " + data.SunEndTime.toString()
          }
        ];
    
        
        scheduleTemp = scheduleTemp.map((item) =>{
          //console.log(item)
          if(item.beg == 0 && item.end == 0){
            item.sch =  "выходной" 
          }
          if(item.beg == 0 && item.end == 24)
            item.sch =  "круголосуточно" 
          return item
        })
        let res = Object.values(scheduleTemp.reduce((acc, item) => {
          if (!acc[item.sch]) 
            acc[item.sch] = {
                sch: item.sch,
                result: []
            };
          acc[item.sch].result.push(item.dayText);
          return acc;
        }, {}))
        //console.log(res)
        let today = moment().local()
        //console.log(today)
        let todaySchedule = scheduleTemp.find((p) => p.day == today.day())
        //console.log(today.day())
        //console.log(todaySchedule)
        if(todaySchedule.beg < today.hour() && todaySchedule.end >= today.hour() )
        {
          setIsNowOpen(true)
        }
        else{
          setIsNowOpen(false)
        }
        let totalTime = scheduleTemp.reduce((accumulator, object) => {
          //console.log(object)
          return accumulator + (object.end -object.beg);
        }, 0);
        //console.log(totalTime)
        if(totalTime == 0)
          setPointSchedule(null)
        else
          setPointSchedule(res)
        }
        catch
        {
          setPointSchedule(null)
        }
      }

    return (
        <Grid
            container
            item={true}
            xs={11}
            md={6}
            lg={4} 
            style={{
                position: "absolute",
                top: "3vh",
                right: "2vw"
            }}>
            <Stack direction="row" width="100%">
                {/* <Box mt={2} onClick={props.onHide} sx={{cursor: "pointer"}}>
                    <img src={CloseLogo} height={40} width={40}/>
                </Box> */}
                <Box 
                    flex={1} 
                    overflow="auto"
                    style={{
                        backgroundColor: "white",
                        borderRadius: 20,
                        height: "90vh",
                        overflowY: "scroll",
                    }}
                > 
                <Box p={2}>
                    <Grid container py={3}>
                        <Grid item xs={11} alignItems="center" justifyContent="end">
                            <Stack direction="row" spacing={1}> 
                            <Typography variant="h6" fontWeight={700} fontFamily="Manrope" lineHeight={1}>
                                {props.data.Name}
                            </Typography>
                                {props.data.IsUser && <Tooltip title="Данные пользвователей Уберу"><img src={VerifyUser} height={24} width={24}/></Tooltip>}
                                {props.data.CompanyId !== null && <Tooltip title="Данные владельца пункта"><img src={VerifyCompany} height={24} width={24}/></Tooltip>}
                                {props.data.IsReoValidated &&  <Tooltip title="Данные РЭО"><img src={VerifyReo} height={24} width={24}/></Tooltip>}
                            </Stack>
                        </Grid>
                        <Grid item xs={1} onClick={props.onHide} sx={{cursor: "pointer"}} alignItems="" justifyContent="center">
                            <img src={CloseLogo} height={24} width={24}/>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={4} onClick={() => setTabSelected(0)} sx={{cursor: "pointer"}}>
                            <Typography variant="body1" align="center" p={1} fontFamily="Manrope">
                                Информация
                            </Typography>
                            {tabSelected== 0 && <Box style={{height: "3px", backgroundColor:uberuGreenColor, borderRadius: "3px", width: "100%"}}></Box>}
                        </Grid>
                        <Grid item xs={4} onClick={() => setTabSelected(1)} sx={{cursor: "pointer"}}>
                            <Grid container alignContent="center" justify="center">
                                <Grid  item xs={12} md={8}>
                                <Typography variant="body1"  align="center" py={1} fontFamily="Manrope" pr={1} >
                                    Фото
                                </Typography>
                                </Grid>
                                <Grid item md={4} sx={{ display: { xs: 'none', md: 'block' } }} alignContent="left" justifyContent="left">
                                    <Box sx={{backgroundColor: uberuLightGreen2Color, borderRadius: 15,  width: "40px", height: "40px", color: uberuGreenColor, textAlign: "center", py: 1}}>
                                        <Typography variant="body1"  align="center" fontFamily="Manrope" >
                                            {imagesPoint.length}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                            {tabSelected== 1 && <Box style={{height: "3px", backgroundColor:uberuGreenColor, borderRadius: "3px", width: "100%"}}></Box>}
                        </Grid>
                        <Grid item xs={4} onClick={() => setTabSelected(2)} sx={{cursor: "pointer"}}>
                            <Typography variant="body1"  align="center" p={1} fontFamily="Manrope">
                                Контакты
                            </Typography>
                            {tabSelected== 2 && <Box style={{height: "3px", backgroundColor:uberuGreenColor, borderRadius: "3px", width: "100%"}}></Box>}
                        </Grid>
                    </Grid>
                    {tabSelected== 0 &&
                    <Box>

                        <Box style={{ overflow: 'auto', overflowX: "auto"}} p={1}>
                            {(props.data.Address != null &&  props.data.Address.toString().toLowerCase() != "null") &&
                            <Typography variant="subtitle1" pt={1.2} fontWeight={400} fontFamily="Manrope" lineHeight={1.2}>
                                {props.data.Address}
                            </Typography>}
                            {props.data.Comment != "tree" ?
                            <>
                            <Typography variant="subtitle1"  pt={2}  fontWeight={700} fontFamily="Manrope">
                                Типы принимаемых отходов:
                            </Typography>
                            <Grid container sx={{ overflowX: "scroll", maxHeight: "250px" }} pt={1}>
                                <Stack direction="row" space={2}>
                                {props.data.WPet == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={PetLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                            ПЭТ&#8209;бутылки
                                        </Typography>
                                    </Box>
                                 </Box>}
                                {props.data.WPlastic == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={PlasticLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                            Пластик
                                        </Typography>
                                    </Box>
                                </Box>}
                                {props.data.WCaps == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={CapLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                            Крышечки
                                        </Typography>
                                    </Box>
                                </Box>}
                                {props.data.WAluminium == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={AluLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                            Алюмин.банки
                                        </Typography>
                                    </Box>
                                </Box>}
                                {props.data.WGlass == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={GlassLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                            Стекло
                                        </Typography>
                                    </Box>
                                </Box>}
                                {props.data.WPaper == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={PaperLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                            Бумага
                                        </Typography>
                                    </Box>
                                </Box>}
                                {(props.data.WMetall == true ||  props.data.WMetallColoured == true) &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={MetalLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                            Металл
                                        </Typography>
                                    </Box>
                                </Box>}
                                {props.data.WBatteries == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={BatteryLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                        Батарейки
                                        </Typography>
                                    </Box>
                                </Box>}
                                {props.data.WDangerous == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={HazardLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                        Опасные отходы
                                        </Typography>
                                    </Box>
                                </Box>}
                                {props.data.WAppliances == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={AppliancesLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                            Бытовая техника
                                        </Typography>
                                    </Box>
                                </Box>}
                                {props.data.WWear == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={WearLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                            Одежда
                                        </Typography>
                                    </Box>
                                </Box>}
                                {props.data.WShoes == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={ShoesLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                            Обувь
                                        </Typography>
                                    </Box>
                                </Box>}
                                {props.data.WLamps == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={LampLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                        Лампочки
                                        </Typography>
                                    </Box>
                                </Box>}
                                {props.data.WTetrapak == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={TetrapakLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                        Тетрапак
                                        </Typography>
                                    </Box>
                                </Box>}
                                {props.data.WTyres == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={TyreLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                            Шины
                                        </Typography>
                                    </Box>
                                </Box>}
                                {props.data.WMedicine == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={MedicineLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                            Медотходы
                                        </Typography>
                                    </Box>
                                </Box>}
                                {props.data.WOther == true &&
                                <Box width="100px">
                                    <Box justifyContent="center" alignItems="center" width="80px">
                                        <img src={OtherLogo} alt='Pet Logo' width='50px' height='50px' style={{display: "block", marginLeft: "auto", marginRight: "auto"}}/>
                                        <Typography variant="body2" fontFamily="Manrope" textAlign="center" pt={2}>
                                            Другое
                                        </Typography>
                                    </Box>
                                </Box>}

                                </Stack>
                            </Grid>
                            </>
                            : <Typography variant="subtitle1"  pt={2}  fontWeight={700} fontFamily="Manrope">
                                Прием елок
                            </Typography>}

                            <Typography variant="subtitle1"  pt={2}  fontWeight={700} fontFamily="Manrope">
                                Описание:
                            </Typography>
                            <Typography variant="body" fontFamily="Manrope"  pt={2}>{props.data.Description}</Typography>
                                
                            <Typography variant="subtitle1"  pt={2}  fontWeight={700} fontFamily="Manrope">
                                Тип пункта:
                            </Typography>
                            <Grid container>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1"  fontWeight={400} fontFamily="Manrope">
                                        {pointTypes.find(p => p.Id == props.data.Type).Name}
                                    </Typography>
                                </Grid>
                                {props.data.IsPrivate &&
                                <Grid item xs={6}>
                                    <Stack direction="row" space={1}>
                                        <img
                                            src={WarningLogo}
                                            height="18"
                                            width="18"
                                            />
                                        <Typography color={uberuRedColor} variant="body" fontFamily="Manrope" pl={1}>Ограниченный доступ</Typography>
                                    </Stack>
                                </Grid>
                                }
                            </Grid>
                            {pointSchedule != null
                            && <Box py={1}>
                              <Typography variant="subtitle1"  pt={2}  fontWeight={700} fontFamily="Manrope">
                                График работы:
                              </Typography>
                              <Grid container>
                              <Grid item xs={8}>
                                {pointSchedule.map((item) => 
                                    <Stack direction="column" key={item.sch}>
                                        <Typography variant="body" fontFamily="Manrope">{item.result.map((day) => day + " ")} {item.sch}</Typography>
                                    </Stack>
                                )}
                              </Grid>
                              <Grid item xs={4}>
                                {isNowOpen
                                ? <Box>
                                    <Typography color={uberuLightGreenColor}  variant="body" fontFamily="Manrope">Сейчас открыто</Typography>
                                    </Box>
                                : <Stack direction="row" space={1}>
                                    <img
                                        src={WarningLogo}
                                        height="18"
                                        width="18"
                                        />
                                    <Typography color={uberuRedColor} variant="body" fontFamily="Manrope" pl={1}>Сейчас закрыто</Typography>
                                 </Stack>
                                }
                              </Grid>
                              </Grid>
                            </Box>}
                           
                            {/* {props.data.BonusProgram == 3 && 
                            <Typography variant="subtitle1"  fontWeight={400} fontFamily="Manrope" pt={2}> &#x267A; Здесь макулатуру принимают волонтеры движения «Экосистема»</Typography>
                            } */}
                        </Box>
                    </Box>}
                    {tabSelected== 1 &&
                        <Box style={{ width: '100%', overflow: 'auto'}} p={1}>
                            <ImageList cols={2}>
                                {imagesPoint.map((item) => (
                                    <ImageListItem key={item}>
                                    <img
                                        srcSet={item}
                                        src={item}
                                        alt="image"
                                        loading="lazy"
                                        style={{borderRadius: "10px"}}
                                    />
                                    </ImageListItem>
                                ))}
                                </ImageList>
                        </Box>}
                    {tabSelected== 2 &&
                    <Box style={{ width: '100%', overflow: 'auto'}} p={1}>
                            {props.data.Phone &&  props.data.Phone != "null" &&
                            <>
                                <Typography variant="subtitle1"  pt={2}  fontWeight={700} fontFamily="Manrope">
                                    Телефон:
                                </Typography>
                                <Link variant="subtitle1"  href={'tel:' + props.data.Phone} fontWeight={400} fontFamily="Manrope" color={uberuLightGreenColor}>
                                    {props.data.Phone}
                                </Link>
                            </>}
                            {props.data.Web &&  props.data.Web != "null" &&
                            <>
                                <Typography variant="subtitle1"  pt={2}  fontWeight={700} fontFamily="Manrope">
                                    Веб-сайт:
                                </Typography>
                                <Link variant="subtitle1" target="_blank" href={props.data.Web.includes("http") ? props.data.Web : "https://" + props.data.Web } fontWeight={400} fontFamily="Manrope" color={uberuLightGreenColor}>
                                    {props.data.Web}
                                </Link>
                            </>}
                            {props.data.Email  &&  props.data.Email != "null" &&
                            <>
                                <Typography variant="subtitle1"  pt={2}  fontWeight={700} fontFamily="Manrope">
                                    Электронный адрес:
                                </Typography>
                                <Link variant="subtitle1" href={"mailto:"+props.data.Email}  fontWeight={400} fontFamily="Manrope" color={uberuLightGreenColor}>
                                    {props.data.Email}
                                </Link>
                            </>}
                    </Box>}
                    </Box>
                </Box>
            </Stack>
        </Grid>
    );
}

export default ModalUberu;